// extracted by mini-css-extract-plugin
export default {"icon":"icons_icon__Fs3+0","hoverable":"icons_hoverable__Bb2h3"};